export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8469.07a912fe.jpg";